function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, useRef, Ref, RefObject, CSSProperties, MouseEventHandler } from 'react';
import cn from 'classnames';
import { Button, ButtonSizes } from '../Button';
import { Icon } from '../Icon';
import { Carousel, useCarouselState } from '../../_internal_/components/Carousel';
import Dots from './Dots/Slider-Dots';
import { useForkRef } from '../../hooks/useForkRef';
require("./Slider.css");
var styles = {
  "Root": "Slider-module-Root_e3t",
  "Carousel": "Slider-module-Carousel_2fC",
  "Arrow": "Slider-module-Arrow_x86",
  "ArrowNext": "Slider-module-ArrowNext_20e",
  "ArrowPrev": "Slider-module-ArrowPrev_3Np"
};
export const Slider = ({
  children,
  className,
  controlRef,
  hasArrows = false,
  arrowValueTop = 50,
  hasDots = false,
  innerRef,
  onChangeSelected,
  selectedIndex = 0,
  slidesToScroll = 1,
  slidesToShow = 1,
  style = {},
  ...props
}) => {
  const scrollRef = useRef(null);
  const ownRef = useForkRef(scrollRef, controlRef);
  const {
    state,
    setSelectedIndex
  } = useCarouselState({
    length: Array.isArray(children) ? children.length : 0,
    selectedIndex,
    slidesToScroll,
    slidesToShow,
    viewportRef: scrollRef
  });
  const length = Math.ceil(state.length / state.slidesToScroll);
  if (!Array.isArray(children)) return null;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: cn(styles.Root, className),
    style: style,
    ref: innerRef
  }, props), hasArrows && state.selectedIndex > 0 && /*#__PURE__*/React.createElement(Button, {
    "aria-label": "\u041F\u0440\u0435\u0434\u044B\u0434\u0443\u0449\u0438\u0439 \u0441\u043B\u0430\u0439\u0434",
    className: cn(styles.Arrow, styles.ArrowPrev),
    style: {
      top: arrowValueTop + '%'
    },
    size: ButtonSizes.s,
    value: state.selectedIndex - state.slidesToScroll,
    onClick: setSelectedIndex
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevronBack"
  })), state.viewportWidth > 0 && /*#__PURE__*/React.createElement("div", {
    className: styles.Carousel
  }, /*#__PURE__*/React.createElement(Carousel, _extends({
    innerRef: ownRef,
    setSelectedIndex: setSelectedIndex
  }, state), children)), hasArrows && state.selectedIndex < state.maxLimiter && /*#__PURE__*/React.createElement(Button, {
    "aria-label": "\u0421\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0439 \u0441\u043B\u0430\u0439\u0434",
    className: cn(styles.Arrow, styles.ArrowNext),
    style: {
      top: arrowValueTop + '%'
    },
    size: ButtonSizes.s,
    value: state.selectedIndex + state.slidesToScroll,
    onClick: setSelectedIndex
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "chevronRight"
  })), hasDots && /*#__PURE__*/React.createElement(Dots, {
    length: length,
    setSelectedIndex: setSelectedIndex,
    selectedIndex: state.selectedIndex,
    slidesToScroll: state.slidesToScroll
  }));
};
if (process.env.NODE_ENV !== 'production') {
  Slider.displayName = 'Slider';
}